import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import Progress from "../../../../../../ui/Progress";
import TopBar from "./TopBar";
import Box from "../../../../../../ui/Box";
import OrgRequestDrawer from "../../components/OrgRequestDrawer";
import OrgRequestFullInfo from "./OrgRequestFullInfo";
import DeleteConfirmationModal from "../../../../../../ui/DeleteConfirmationModal";
import useRequestView from "./useRequestView";
import AcceptRequestModal from "./AcceptRequestModal";
import DeclineRequestModal from "./DeclineRequestModal";
import RestoreRequestModal from "./RestoreRequestModal";

const useStyles = makeStyles(() => ({
  viewRoot: {
    display: "flex",
    background: "#F6FBFF"
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  },
  mainContent: {
    padding: 8,
    maxWidth: 816
  },
  form: {
    width: 385
  },
  twoColumns: {
    display: "flex"
  },
  caption: {
    color: "#778899",
    fontSize: 10,
    marginBottom: 16
  }
}));

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Организации",
    link: "/work/app/manage/resources/org"
  },
  {
    label: "Заявки организаций",
    link: "/work/app/manage/resources/org/requests"
  },
];

const OrgRequestView = ({ match, history}) => {
  const { id } = match.params;
  const classes = useStyles();

  const {
    requestData: {
      requestInfo,
      deleteModalOpen,
      acceptModalOpen,
      declineModalOpen,
      restoreModalOpen,
      isUpdatingRequest,
      isAcceptingRequest,
      isDecliningRequest,
      isRestoringRequest,
      acceptedRequest,
      declinedRequest,
      restoredRequest,
      isEdited,
    },
    setRequestData,
    updateRequest,
    deleteRequest,
    acceptRequest,
    declineRequest,
    restoreRequest,
    getRequestInfo
  } = useRequestView();

  const [isEditable, setEditable] = React.useState(false);

  const returnBack = () => {
    history.push("/work/app/manage/resources/org/requests");
  }

  const reloadRequest = () => {
    getRequestInfo(id);
  }

  useEffect(() => {
    getRequestInfo(id);
  }, []);

  return (
    <div>
      {requestInfo &&
      <><DeleteConfirmationModal
        modalText="Удалить запрос?"
        open={deleteModalOpen}
        onConfirm={() => {
          deleteRequest(id);
          returnBack();
        }}
        handleClose={() => setRequestData({ deleteModalOpen: false })}
      />
      <RestoreRequestModal
        modalText="Восстановить запрос?"
        open={restoreModalOpen}
        onConfirm={() => {
          restoreRequest(id);
          if (restoredRequest && restoredRequest.success) {
            setRequestData({ restoreModalOpen: false });
            reloadRequest();
          }
        }}
        handleClose={() => setRequestData({ restoreModalOpen: false })}
      />
      <AcceptRequestModal
        requestData={requestInfo.data}
        requestInfo={requestInfo.info}
        open={acceptModalOpen}
        handleClose={() => setRequestData({ acceptModalOpen: false })}
        handleAccept={acceptRequest}
        handleReload={reloadRequest}
        isAcceptingRequest={isAcceptingRequest}
        acceptedRequest={acceptedRequest}
      />
      <DeclineRequestModal
        accountEmail={requestInfo.data.accountEmail}
        requestId={requestInfo.info.id}
        open={declineModalOpen}
        handleClose={() => setRequestData({ declineModalOpen: false })}
        handleDecline={declineRequest}
        handleReload={reloadRequest}
        isDecliningRequest={isDecliningRequest}
        declinedRequest={declinedRequest}
      /></>
      }
      <Breadcrumbs items={items} />
      {requestInfo ? (
        <div className={classes.viewRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                statusId={requestInfo.info.statusId}
                returnBack={returnBack}
                reloadRequest={() => getRequestInfo(id)}
                updateRequest={() => {
                  updateRequest(id, requestInfo.data);
                }}
                isAcceptingRequest={isAcceptingRequest}
                isDecliningRequest={isDecliningRequest}
                isUpdatingRequest={isUpdatingRequest}
                openDeleteModal={() => setRequestData({ deleteModalOpen: true })}
                openAcceptModal={() => setRequestData({ acceptModalOpen: true })}
                openDeclineModal={() => setRequestData({ declineModalOpen: true })}
                openRestoreModal={() => setRequestData({ restoreModalOpen: true })}
                editmode={isEditable}
                setEditMode={()=>setEditable(true)}
                setViewMode={()=>setEditable(false)}
              />
            </div>
            <Box>
                <OrgRequestFullInfo
                  editmode={isEditable}
                  disabled={!requestInfo.info.editable}
                  infoData={requestInfo.info}
                  initialData={requestInfo.data}
                  onFormChange={data =>
                    setRequestData({ requestInfo: { ...requestInfo, data } })}/>
            </Box>
          </div>
          <OrgRequestDrawer reqId={id} open hideLink />
        </div>
      ) : (
        <Progress />
      )}
    </div>
  );
};

export default withRouter(OrgRequestView);
